import { CONFIG_PAGES, PERMISSIONS } from "@miplatform/constants";
import { CONFIG_PATHS, MODULES_CONFIG_PATHS } from "./config/constants";
import { PATHS } from "./paths";

export const PATHS_PERMISSIONS: Record<string, string[]> = {
  [PATHS.CONFIG]: [
    PERMISSIONS.MI_DISPATCH.ADMINISTRATION,
    PERMISSIONS.MI_SCHEDULING.ADMINISTRATION,
    PERMISSIONS.MI_INSPECTIONS.ADMINISTRATION,
    PERMISSIONS.MI_ACCOUNTING.ADMINISTRATION,
    PERMISSIONS.MI_ESTIMATING.ADMINISTRATION,
    PERMISSIONS.HR.ADMINISTRATION,
    PERMISSIONS.OPERATIONS.ADMINISTRATION,
  ],
  // MiPlatform Modules
  [PATHS.MI_DISPATCH]: [PERMISSIONS.MI_DISPATCH.ACCESS],
  [PATHS.MI_SCHEDULING]: [PERMISSIONS.MI_SCHEDULING.ACCESS],
  [PATHS.MI_ACCOUNTING]: [PERMISSIONS.MI_ACCOUNTING.ACCESS],
  [PATHS.MI_INSPECTIONS]: [PERMISSIONS.MI_INSPECTIONS.ACCESS],
  [PATHS.MI_ESTIMATING]: [PERMISSIONS.MI_ESTIMATING.ACCESS],
  [PATHS.SETTINGS]: [PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION],
  [PATHS.HOMES]: [PERMISSIONS.HOME.READ],
  [PATHS.CUSTOMERS]: [
    PERMISSIONS.SERVICE_CUSTOMER.READ,
    PERMISSIONS.BUILDER.READ,
  ],
  [PATHS.VENDORS]: [PERMISSIONS.SUPPLIER.READ, PERMISSIONS.SUBCONTRACTOR.READ],
  // MiConfig Modules
  [CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH]]: [
    PERMISSIONS.MI_DISPATCH.ADMINISTRATION,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING]]: [
    PERMISSIONS.MI_SCHEDULING.ADMINISTRATION,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.MI_INSPECTIONS]]: [
    PERMISSIONS.MI_INSPECTIONS.ADMINISTRATION,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.MI_ACCOUNTING]]: [
    PERMISSIONS.MI_ACCOUNTING.ADMINISTRATION,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.MI_ESTIMATING]]: [
    PERMISSIONS.MI_ESTIMATING.ADMINISTRATION,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.HR]]: [PERMISSIONS.HR.ADMINISTRATION],
  [CONFIG_PATHS[CONFIG_PAGES.OPERATIONS]]: [
    PERMISSIONS.OPERATIONS.ADMINISTRATION,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.ORDER_TEMPLATES]]: [
    PERMISSIONS.ORDER_TEMPLATE.READ,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.ROLES_OPERATIONS]]: [PERMISSIONS.ROLE.READ],
  [CONFIG_PATHS[CONFIG_PAGES.ROLES_HR]]: [PERMISSIONS.ROLE.READ],
  [CONFIG_PATHS[CONFIG_PAGES.DEPARTMENTS]]: [PERMISSIONS.DEPARTMENTS.READ],
  [CONFIG_PATHS[CONFIG_PAGES.HOLIDAYS]]: [PERMISSIONS.TENANT_HOLIDAY.READ],
  [CONFIG_PATHS[CONFIG_PAGES.DOCUMENT_TYPES]]: [
    PERMISSIONS.DOCUMENT_CATEGORY.READ,
  ],
  [CONFIG_PATHS[CONFIG_PAGES.INSPECTION_AUTHORITIES]]: [PERMISSIONS.OPERATIONS.ADMINISTRATION],
  [CONFIG_PATHS[CONFIG_PAGES.CITIES]]: [PERMISSIONS.OPERATIONS.ADMINISTRATION],
  [CONFIG_PATHS[CONFIG_PAGES.SETTINGS]]: [
    PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION,
  ],
  [MODULES_CONFIG_PATHS[CONFIG_PAGES.MI_DISPATCH][
    CONFIG_PAGES.ORDER_CALENDARS
  ]]: [PERMISSIONS.MI_DISPATCH.ADMINISTRATION],
  [MODULES_CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING][
    CONFIG_PAGES.ORDER_CALENDARS
  ]]: [PERMISSIONS.MI_SCHEDULING.ADMINISTRATION],
  [MODULES_CONFIG_PATHS[CONFIG_PAGES.MI_SCHEDULING][
    CONFIG_PAGES.WORK_ORDER_CALENDARS
  ]]: [PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION],
};
